import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { customerResource } from '../../system/customerManage/request';
import { pushScenarioResource, messageConfigList, structureResource, messageConfigChangeStatus } from './request';
export default {
  data() {
    const h = this.$createElement;
    return {
      form: {
        pushScenario: undefined,
        remark: undefined,
        messageCategory: undefined,
        customerId: undefined,
        structureType: undefined,
        associationId: undefined
      },
      columns: [{
        dataIndex: 'index',
        width: 80,
        slots: {
          title: '序号'
        },
        align: 'center'
      }, {
        dataIndex: 'customerName',
        width: 200,
        slots: {
          title: '客户名称'
        },
        align: 'center'
      }, {
        dataIndex: 'structureName',
        width: 200,
        slots: {
          title: '适用架构'
        },
        align: 'center',
        ellipsis: true,
        customRender: (text, record) => {
          return h("a-tooltip", {
            "attrs": {
              "title": text.replace('全部', this.$t('全部'))
            }
          }, [h("span", {
            "class": "overflow-text"
          }, [text.replace('全部', this.$t('全部')) || '-'])]);
        }
      }, {
        dataIndex: 'messageCategoryName',
        width: 200,
        slots: {
          title: '消息类别'
        },
        align: 'center',
        customRender: text => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'pushScenarioName',
        width: 200,
        slots: {
          title: '推送场景'
        },
        align: 'center',
        customRender: text => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'status',
        width: 200,
        slots: {
          title: '状态'
        },
        scopedSlots: {
          customRender: 'status'
        },
        align: 'center'
      }, {
        dataIndex: 'remark',
        width: 200,
        slots: {
          title: '备注'
        },
        align: 'center',
        ellipsis: true,
        customRender: text => {
          let newText = text ? text.replace('全部', this.$t('全部')) : text;
          return h("a-tooltip", {
            "attrs": {
              "title": newText
            }
          }, [h("span", {
            "class": "overflow-text"
          }, [newText || '-'])]);
        }
      }, {
        dataIndex: 'action',
        width: 200,
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }],
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      customersList: [],
      pushScenarioList: [],
      structureList: [],
      structureListTree: []
    };
  },
  created() {
    customerResource().then(res => {
      //获取客户资源列表
      this.customersList = res;
    });
    this.getList();
  },
  computed: {
    pushScenarioPlaceholder() {
      return this.form.messageCategory ? `${this.$t('请选择') + this.$t('推送场景')}` : `${this.$t('请先选择消息类别')}`;
    },
    structureTypePlaceholder() {
      return this.form.customerId ? `${this.$t('请选择') + this.$t('适用架构')}` : `${this.$t('请先选择客户名称')}`;
    }
  },
  methods: {
    customerIdChange(value) {
      this.form.structureType = undefined;
      this.form.associationId = undefined;
      this.structureList = [];
      this.structureListTree = [];
      if (value || value === 0) {
        this.getStructureResource();
      }
    },
    getStructureResource() {
      let params = {
        customerId: this.form.customerId
      };
      let loop = data => {
        return data.map(item => {
          let obj = {
            title: item.name,
            value: item.id,
            name: item.name,
            id: item.id,
            label: item.name,
            disabled: true,
            key: item.id
          };
          if (item.children && item.children.length) {
            obj.children = loop(item.children);
          }
          if (item.userInfo && item.userInfo.length > 0) {
            obj.children = obj.children || [];
            item.userInfo.forEach(userItem => {
              let user = {
                title: userItem.nickName,
                value: userItem.userId,
                name: userItem.nickName,
                id: userItem.userId,
                label: userItem.nickName,
                key: userItem.userId
              };
              obj.children.push(user);
            });
          }
          return obj;
        });
      };
      const loop2 = data => {
        return data.map(item => {
          let obj = {
            title: item.name,
            value: item.id,
            name: item.name,
            id: item.id,
            label: item.name,
            key: item.id
          };
          if (item.children && item.children.length) {
            obj.children = loop2(item.children);
          }
          return obj;
        });
      };
      structureResource(params).then(res => {
        if (res && res.length) {
          this.structureList = Array.isArray(res) && res !== null && res !== void 0 && res.length ? loop2(res) : [];
          this.structureListTree = Array.isArray(res) && res !== null && res !== void 0 && res.length ? loop(res) : [];
        }
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getList();
    },
    reset() {
      this.form.customerId = undefined;
      this.form.remark = undefined;
      this.form.structureType = undefined;
      this.form.associationId = undefined;
      this.form.messageCategory = undefined;
      this.form.pushScenario = undefined;
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      var _this$form, _this$form2, _this$form$associatio;
      let remark = (_this$form = this.form) === null || _this$form === void 0 || (_this$form = _this$form.remark) === null || _this$form === void 0 ? void 0 : _this$form.trim();
      let key = this.$t('全部');
      remark = remark ? remark.replace(key, '全部') : '';
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        structureType: ((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.structureType) || '',
        associationId: (_this$form$associatio = this.form.associationId) !== null && _this$form$associatio !== void 0 && _this$form$associatio.length ? this.form.associationId.join(',') : this.form.associationId,
        customerId: this.form.customerId || '',
        remark: remark || '',
        messageCategory: this.form.messageCategory || '',
        pushScenario: this.form.pushScenario || ''
      };
      messageConfigList(params).then(res => {
        this.dataSource = res.items;
        this.pagination.total = Number(res.totalNum);
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getList();
    },
    flowTypeIdChange(value) {
      this.form.pushScenario = undefined;
      this.pushScenarioList = [];
      if (value) {
        pushScenarioResource({
          messageCategory: value
        }).then(res => {
          this.pushScenarioList = res;
        });
      }
    },
    structureTypeChange() {
      this.form.associationId = undefined;
    },
    checkedFun(record) {
      let params = {
        messageConfigId: record.id,
        status: record.status === 1 ? 0 : 1
      };
      messageConfigChangeStatus(params).then(res => {
        if (res === true) {
          this.$message.success(this.$t('操作成功') + '!');
          this.$set(record, 'status', record.status === 1 ? 0 : 1);
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    checkedItem(val) {
      return val === 1 ? true : false;
    },
    newMessage() {
      this.$router.push({
        name: 'newMessageSetting',
        params: {
          id: -1,
          copyId: -1
        }
      });
    },
    editMessage(record) {
      this.$router.push({
        name: 'newMessageSetting',
        params: {
          id: record.id,
          copyId: -1
        }
      });
    },
    copyMessage(record) {
      this.$router.push({
        name: 'newMessageSetting',
        params: {
          id: -1,
          copyId: record.id
        }
      });
    }
  }
};